import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {usePageURLContext} from "../../../contexts/pageURLContext";
import {requestListofAlerts} from "../../../redux/Actions/alerts.actions";
import {
  getAlertsList,
  getTotalCount,
  getPaginationUrls,
} from "../../../redux/Selectors/alerts.selector";
import {generateQueryUrl} from "../../../helpers/generateQueryUrl";
import {alertListURL} from "./alertTable.constants";

export const useFetchAlerts = () => {
  const {pageUrl} = usePageURLContext();
  const dispatch = useDispatch();

  const freshFetch = () => {
    dispatch(requestListofAlerts());
  };

  const refetch = () => {
    dispatch(requestListofAlerts(pageUrl));
  };

  return {refetch, freshFetch};
};

export const useAlertTableData = () => {
  const dispatch = useDispatch();
  const {refetch, freshFetch} = useFetchAlerts();
  const {setPageUrl} = usePageURLContext();
  const [currentPage, setCurrentPage] = useState(1);
  const alertsList = useSelector(getAlertsList);
  const alertTotalCount = useSelector(getTotalCount);
  const alertUrls = useSelector(getPaginationUrls);

  useEffect(() => {
    freshFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAfterDelete = () => {
    if (alertsList.length === 1) {
      // If the last alert on the current page is deleted, reset to the first page
      setCurrentPage(1);
      setPageUrl("");
      freshFetch();
    } else {
      refetch();
    }
  };

  const handlePageChange = (page) => {
    const url = currentPage < page ? alertUrls?.nextUrl : alertUrls?.prevUrl;
    dispatch(requestListofAlerts(url));
    setCurrentPage(page);
    setPageUrl(url);
  };

  const paginationConfig = {
    currentPage,
    onPageChange: handlePageChange,
  };

  const handleSearch = (tokens) => {
    if (tokens?.length > 0) {
      const searchUrl = generateQueryUrl(alertListURL, tokens);
      dispatch(requestListofAlerts(searchUrl));
      setPageUrl(searchUrl);
      setCurrentPage(1);
    } else {
      dispatch(requestListofAlerts());
      setPageUrl("");
      setCurrentPage(1);
    }
  };

  return {
    alertsList,
    alertTotalCount,
    fetchAfterDelete,
    handleSearch,
    paginationConfig,
  };
};
